import {SimpleApiTyped} from './simpleApi'
import {urlEncode} from './tagFuncs'

const gatewayApiName = 'IbtAPIGateway'

export interface LastDataChange {
    customer: string
    uuid: string
    resourceType: string
    lastDataChange: ReadonlyMap<string, number>
    lastDeploymentTimestamp: number
}

export class LastDataChangeService {
    async getLastDataChangeForRK(customerId: string, readykit: string): Promise<LastDataChange> {
        const path = urlEncode`/last-data-change/${customerId}/${readykit}`
        const response = await SimpleApiTyped.get<LastDataChange>(gatewayApiName, path)
        response.lastDataChange = new Map(Object.entries(response.lastDataChange))
        return response
    }
}

export default LastDataChangeService
